import { TextField, Button, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";

function WEFChangePage({ Page, PageButtonStatus }) {
  const pages = [
    {
      label: "Basic Info",
      Prop: "BasicInfo",
      link: "ViewBasicInfo",
    },
    {
      label: "General Info",
      Prop: "GeneralInfo",
      link: "ViewGeneralInfo",
    },
    {
      label: "Emergency Medical Info",
      Prop: "EmergancyMedicalInfo",
      link: "ViewEmergancyMedicalInfo",
    },
    {
      label: "SEND Info",
      Prop: "SENDInfo",
      link: "ViewSENDInfo",
    },

    {
      label: "Contact Info",
      Prop: "ContactInfo",
      link: "ViewContactInfo",
    },
    {
      label: "Declarations",
      Prop: "PermissionsInfo",
      link: "ViewPermissionsInfo",
    },
  ];

  //given Page, return the next page in the arrayIf non exists, return "Home"
  function getNextPage(Page) {
    let index = pages.findIndex((page) => page.Prop === Page);
    if (index === -1) {
      throw new Error("Page not found");
    }
    if (index === pages.length - 1) {
      return { Link: "/Student", Name: "Home" };
    } else {
      return {
        Link: `/Student/${pages[index + 1].link}/${localStorage.getItem(
          "Student_id"
        )}`,
        Name: pages[index + 1].label,
      };
    }
  }

  //given Page, return the last page in the array. If non exists, return "Home"
  function getLastPage(Page) {
    let index = pages.findIndex((page) => page.Prop === Page);
    if (index === -1) {
      throw new Error("Page not found");
    }
    if (index === 0) {
      return { Link: "/Student", Name: "Home" };
    } else {
      return {
        Link: `/Student/${pages[index - 1].link}/${localStorage.getItem(
          "Student_id"
        )}`,
        Name: pages[index - 1].label,
      };
    }
  }
  if (PageButtonStatus) {
    return (
      <div className="view-basic-info-buttons">
        <Button
          variant="contained"
          color="secondary"
          component={Link}
          to={getLastPage(Page).Link}
        >
          Go To {getLastPage(Page).Name}
        </Button>

        <Button
          variant="contained"
          color="secondary"
          component={Link}
          to={getNextPage(Page).Link}
        >
          Go To {getNextPage(Page).Name}
        </Button>
      </div>
    );
  } else {
    return <></>;
  }
}

export default WEFChangePage;
